import ArticleConstructorForm from './component';

export default ArticleConstructorForm;
